import { h, Component } from 'preact'
import { useEffect, useState } from "preact/hooks";
import Renderer from '../canvas/renderer';
import util from '../util';
import { LinkOutlined } from "@ant-design/icons";

export default function HyperlinkWidget({ $element, href, isHyperlink, updateElementAttribute, hasPdfPermission, setActiveMember }) {
	const [hyperlink, setHyperlink] = useState(href);

	// const [, updateState] = useState();
	// const forceUpdate = useCallback(() => updateState({}), []);

	useEffect(() => {
		setHyperlink(href || '');
  }, [href, $element, isHyperlink]);

	function add() {
		if (!hasPdfPermission) {
			window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: setActiveMember });
			return;
		}
		Renderer.addHyperlink($element, hyperlink);
		updateElementAttribute('isHyperlink', true);
		updateElementAttribute('href', util.getValidUrl(hyperlink));
		$('.dropdown-menu:not(.nested)').removeClass('show');
	}

	function remove() {
		Renderer.removeHyperlink($element);
		updateElementAttribute('isHyperlink', false);
		updateElementAttribute('href', '');
		$('.dropdown-menu:not(.nested)').removeClass('show');
		setHyperlink('');
	}

	return (
		<div className="dropdown">
			<a className={"dropdown-toggle icn rwd-icon hint--bottom" + (isHyperlink ? ' act' : '')} data-hint="Hyperlink">
				<LinkOutlined />
			</a>
			<div className="dropdown-menu" style="right: 0px;" data-close="no">
				<div className="angle right" />
				<div className="hyperlink-setup">
					<p>Enter a link</p>
					<span>Links are supported on PDFs and Share Links.</span>

					<input placeholder='https://www.website.com' value={hyperlink} onChange={ev => setHyperlink(ev.target.value)} />

					<div className="buttons">
						{ isHyperlink ? <a class="btn secondary1" onClick={remove}>Remove</a> : '' }
						<a class="btn primary" onClick={add}>{ isHyperlink ? 'Save' : 'Ok' }
							{!hasPdfPermission && <img src="https://www.musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" />}
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
